<template>
  <div></div>
</template>

<script>
export default {
  name: "icon-options-style"
}
</script>

<style lang="scss" scoped>
.button-styles {
  justify-content: space-between;
  flex-wrap: wrap;
  .button-style-item {
    // min-width: 33%;
    width: calc((100% - 16px) / 3);
    margin: 0 4px 12px;
    box-sizing: border-box;
    border-radius: 4px;
    // border: 1px solid #e9e9e9;
    text-align: center;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .img-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
        .icon-checked {
          display: block;
        }
      }
    }
    .img-style-box {
      position: relative;
      height: 53px;
      line-height: 53px;
      border-radius: 4px;
      margin-bottom: 8px;
      background-color: var(--styleBgColor);
      border: 1px solid var(--styleBgColor);
      .icon-checked {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/images/icon-checked.png);
        background-size: 100% 100%;
        display: none;
      }
    }
  }
  .button-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
</style>
